module.exports = __webpack_public_path__ + "img/logo-gary.78680a5c.png";